import React from 'react';

const BettingTab = ({ betStats }) => (
  <div className="space-y-6">
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
      <div className="glass-card p-4 text-center">
        <p className="text-[10px] text-[#666]">TOTAL BETS</p>
        <p className="font-game text-lg text-white">{betStats.total_bets}</p>
      </div>
      <div className="glass-card p-4 text-center">
        <p className="text-[10px] text-[#666]">WIN RATE</p>
        <p className="font-game text-lg" style={{ color: betStats.win_rate >= 50 ? '#14F195' : '#FF3B30' }}>{betStats.win_rate}%</p>
      </div>
      <div className="glass-card p-4 text-center">
        <p className="text-[10px] text-[#666]">WAGERED</p>
        <p className="font-game text-lg text-[#FFD700]">{betStats.total_wagered?.toLocaleString()} SML</p>
      </div>
      <div className="glass-card p-4 text-center">
        <p className="text-[10px] text-[#666]">NET PROFIT</p>
        <p className="font-game text-lg" style={{ color: betStats.net_profit >= 0 ? '#14F195' : '#FF3B30' }}>
          {betStats.net_profit >= 0 ? '+' : ''}{betStats.net_profit?.toLocaleString()} SML
        </p>
      </div>
    </div>
    <div className="glass-card p-5">
      <h2 className="font-game text-sm text-[#FFD700] mb-3">RECORD</h2>
      <div className="flex items-center gap-3">
        <div className="flex-1 bg-[#14F195]/20 rounded h-6 relative overflow-hidden">
          <div className="h-full bg-[#14F195] rounded" style={{ width: `${betStats.win_rate}%` }} />
        </div>
        <span className="text-xs text-white font-game">{betStats.wins}W / {betStats.losses}L</span>
      </div>
    </div>
  </div>
);

export default BettingTab;
